import { createContext } from "react";
import { create } from "zustand";

export const AppContext = createContext();

export const appStore = create((set) => ({
    notifCount: 0,
    dashboardData: null,
    sClient: null,
    increaseCount: () => set((state) => ({ notifCount: state.notifCount + 1 })),
    resetCount: () => set({ notifCount: 0 }),
    updateDashboardData: (data) => set({ dashboardData: data }),
    resetDashboardData: () => set({dashboardData: null}),
    updateSClient: (ins) => set({sClient: ins})
}));